"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var constants = require("../../shared/code/Constants");
function viewSF() {
    var _this = this;
    var textH2Size = function (props) { return ('<h2>' + props.question.text + '</h2>'); };
    var getStateByProps = function (props) { return ({
        instruction: props.question.description,
        constants: constants,
        questionText: textH2Size(props)
    }); };
    return {
        constructor: function (props) {
            _this.state = getStateByProps(props);
        },
        mounted: function () {
        },
        willReceiveProps: function (nextProps) {
            if (nextProps.question.questionId != _this.props.question.questionId) {
                _this.setState(getStateByProps(nextProps));
            }
        },
        events: {}
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/PSQTitleInstructions/ViewSF.js
// module id = 718
// module chunks = 0